var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import moment from 'moment';
import { v4 as uuid } from 'uuid';
import Service, { inject as service } from '@ember/service';
import { computed, set } from '@ember/object';
import { readOnly, not, notEmpty } from '@ember/object/computed';
import { isEmpty } from '@ember/utils';
import { redirect } from '@square/dashboard-utilities/utils/window';
import { jsonPost } from '@square/dashboard-utilities/utils/xhr';
import PlanDetails from '@square/appointments-feature-upsell/models/plan-details';
import { APPOINTMENTS_PREMIUM_TOKEN, APPOINTMENTS_PLUS_TOKEN, APPOINTMENTS_FREE_TOKEN } from '@square/appointments-feature-upsell/services/appointments-feature-info';
import { APPOINTMENTS_LEGACY_TOKEN } from '@square/appointments-feature-upsell/types/features';
import { arrayEqual } from '@square/appointments-feature-upsell/utils/array';
import { BusinessCategory } from '@square/dashboard-protos/models/squareup/onboard/business/categories';
import { BusinessSubcategory } from '@square/dashboard-protos/models/squareup/onboard/business/subcategories';
import { GetMerchantCategoriesResponse } from '@square/dashboard-protos/models/squareup/onboarding/business/common';
function protoToMoment(proto) {
  if (!proto) {
    return null;
  }
  return moment(proto.instant_usec / 1000);
}

// TODO AP-27796: convert calls to these endpoints to RPC
const GET_SUBSCRIPTION_URL = '/services/squareup.appointments.api.ExternalAppointmentsService/GetSubscription';
const APPT_UPDATE_SUBSCRIPTION_URL = '/services/squareup.appointments.api.ExternalAppointmentsService/UpdateSubscription';
const ACKNOWLEDGE_SUBSCRIPTION_URL = '/services/squareup.appointments.api.ExternalAppointmentsService/AcknowledgeSubscription';
const GET_PLAN_GROUP_URL = '/api/v3/subscriptions/external/GetPlanGroup';
export const SUBSCRIPTION_STATUS = {
  ACTIVE: 'ACTIVE',
  ACTIVE_PENDING_CANCELLATION: 'ACTIVE_PENDING_CANCELLATION',
  ACTIVE_PENDING_PAUSE: 'ACTIVE_PENDING_PAUSE',
  CANCELED: 'CANCELED',
  DELINQUENT: 'DELINQUENT',
  FREE_TRIAL: 'FREE_TRIAL',
  FREE_TRIAL_NO_OBLIGATION: 'FREE_TRIAL_NO_OBLIGATION',
  FREE_TRIAL_PENDING_CANCELLATION: 'FREE_TRIAL_PENDING_CANCELLATION',
  IN_GRACE: 'IN_GRACE',
  NO_OBLIGATION_FREE_TRIAL_EXPIRED: 'NO_OBLIGATION_FREE_TRIAL_EXPIRED',
  PAUSED: 'PAUSED'
};
export const SUBSCRIPTION_PAYWALL = {
  NONE: 'NONE',
  SUBSCRIPTION_ENDED: 'SUBSCRIPTION_ENDED',
  SUBSCRIPTION_PAUSED: 'SUBSCRIPTION_PAUSED',
  LOCATION_INACTIVE: 'LOCATION_INACTIVE',
  SUBSCRIPTION_MISSING: 'SUBSCRIPTION_MISSING'
};
export const SUBSCRIPTION_MIGRATION_STATE = {
  UNMIGRATED: 'UNMIGRATED',
  AUTO_MIGRATED: 'AUTO_MIGRATED',
  AUTO_MIGRATION_ACKNOWLEDGED: 'AUTO_MIGRATION_ACKNOWLEDGED',
  MANUALLY_MIGRATED: 'MANUALLY_MIGRATED'
};

// see IGetSubscriptionResponse from @square/dashboard-protos/models/squareup/appointments/api/external_service

// see IExternalGetPlanGroupResponse from @square/dashboard-protos/models/squareup/sub2/v3/external/external_subscription_service

export const APPOINTMENTS_PLAN_GROUP_TOKEN = 'appointments-group';
let AppointmentsSubscriptionService = (_dec = readOnly('subscription.status'), _dec2 = readOnly('subscription.plan_token'), _dec3 = readOnly('subscription.plan_name'), _dec4 = readOnly('subscription.token'), _dec5 = computed('subscription.free_trial_end_at'), _dec6 = computed('freeTrialEndDate', 'intl.primaryLocale'), _dec7 = computed('subscription.end_at'), _dec8 = computed('subscription.pause_at'), _dec9 = computed('subscription.renewal_at'), _dec10 = computed('subscription.start_at'), _dec11 = computed('planToken'), _dec12 = not('isOldPlan'), _dec13 = computed('planToken', 'status'), _dec14 = computed('planToken', 'status'), _dec15 = computed('planToken'), _dec16 = notEmpty('subscription.pending_downgrade.effective_at'), _dec17 = computed('isPendingDowngrade', 'status', 'subscription'), _dec18 = not('isPendingCancellationOrDowngrade'), _dec19 = computed('subscription', 'planToken', 'freeTrialEndDate'), _dec20 = readOnly('dataLoaded'), _dec21 = computed('subscribedLocations.length', 'subscriptionIsFetched'), _dec22 = computed('migrationState'), _class = class AppointmentsSubscriptionService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "appointmentsFeatureInfo", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "store", _descriptor3, this);
    _defineProperty(this, "planDetails", {});
    _defineProperty(this, "activeFeatures", undefined);
    _defineProperty(this, "subscribedLocations", []);
    _defineProperty(this, "subscription", null);
    _defineProperty(this, "paywall", null);
    _defineProperty(this, "migrationState", null);
    _defineProperty(this, "dataLoaded", false);
    _defineProperty(this, "countryCode", null);
    _defineProperty(this, "merchantToken", null);
    _defineProperty(this, "planGroup", null);
    _defineProperty(this, "activeSubunits", []);
    _defineProperty(this, "activeSubunitsFetched", false);
    _initializerDefineProperty(this, "status", _descriptor4, this);
    _initializerDefineProperty(this, "planToken", _descriptor5, this);
    _initializerDefineProperty(this, "planName", _descriptor6, this);
    _initializerDefineProperty(this, "token", _descriptor7, this);
    _initializerDefineProperty(this, "isNewPlan", _descriptor8, this);
    // Logic to determine pending downgrade copied from the subscriptions/sub2-subscription component
    _initializerDefineProperty(this, "isPendingDowngrade", _descriptor9, this);
    _initializerDefineProperty(this, "isNotPendingCancellationOrDowngrade", _descriptor10, this);
    _initializerDefineProperty(this, "subscriptionIsFetched", _descriptor11, this);
    /**
     * Sends a request to Appointments UpdateSubscription.
     * @param selectedPlan New plan whose token of the new plan is needed to update the subscription
     * @param subscribedLocations List of new subscription locations
     * @param reason The reason behind change of plan - it's optional and is only used in the downgrade flow
     * @param selectedPlanComponents List of new plans the merchant wants to subscribe to. Example is 'Team Plus'.
     * @param previousRetryCount The number of retries the request has done. We retry up to 3 times.
     * @returns {Promise<{closeAll: boolean}>}
     */
    _defineProperty(this, "lastParams", null);
  }
  get freeTrialEndDate() {
    return protoToMoment(this.subscription?.free_trial_end_at);
  }
  get freeTrialEndDateMonthDay() {
    if (!this.freeTrialEndDate) {
      return '';
    }
    const endDate = new Date(this.freeTrialEndDate.valueOf());
    return endDate.toLocaleDateString(this.intl.primaryLocale, {
      month: 'long',
      day: 'numeric'
    });
  }
  get subscriptionEndDate() {
    return protoToMoment(this.subscription?.end_at);
  }
  get pauseDate() {
    return protoToMoment(this.subscription?.pause_at);
  }
  get renewalAtDate() {
    return protoToMoment(this.subscription?.renewal_at);
  }
  get startDate() {
    return protoToMoment(this.subscription?.start_at);
  }
  get isOldPlan() {
    return !this.planToken || this.planToken === APPOINTMENTS_LEGACY_TOKEN;
  }
  get canMigrateToNewSaaSTiers() {
    return !this.planToken ||
    // ie sole prop legacy merchant
    this.planToken === APPOINTMENTS_LEGACY_TOKEN &&
    // only legacy subscriptions can migrate
    this.status !== SUBSCRIPTION_STATUS.PAUSED &&
    // paused legacy subscriptions cannot migrate
    this.status !== SUBSCRIPTION_STATUS.IN_GRACE // in_grace legacy subscription cannot migrate
    ;
  }
  get isPlusFreeTrial() {
    return this.planToken === APPOINTMENTS_PLUS_TOKEN && this.status === SUBSCRIPTION_STATUS.FREE_TRIAL_NO_OBLIGATION;
  }
  get isOnFreeSubscription() {
    return this.planToken === APPOINTMENTS_FREE_TOKEN;
  }
  get isPendingCancellationOrDowngrade() {
    return this.isPendingDowngrade || this.status === SUBSCRIPTION_STATUS.FREE_TRIAL_PENDING_CANCELLATION || this.status === SUBSCRIPTION_STATUS.ACTIVE_PENDING_CANCELLATION;
  }
  get freeTrialHasEndedForLegacySubscription() {
    // If it's a legacy merchant, we should check the free_trial_end_at
    // date to make sure they have free trial days left. What sub2
    // returns as part of GetPlanGroup for each new tier, does not
    // consider the trial days used by the legacy subscription.
    return this.subscription && this.planToken === APPOINTMENTS_LEGACY_TOKEN && (!this.freeTrialEndDate || this.freeTrialEndDate.isBefore());
  }
  get hasNoSubscribedLocations() {
    return this.subscriptionIsFetched && this.subscribedLocations.length === 0;
  }
  get needsMigrationAcknowledgement() {
    return this.migrationState === SUBSCRIPTION_MIGRATION_STATE.AUTO_MIGRATED;
  }
  activeSubscriptionPlan() {
    if (this.paywall !== SUBSCRIPTION_PAYWALL.NONE) {
      return null;
    }
    return this.planToken;
  }
  getSubscriptionPlans() {
    return Object.values(this.planDetails);
  }
  get hasAppointmentsPremium() {
    return this.planToken === APPOINTMENTS_PREMIUM_TOKEN;
  }
  isPlanDowngrade(plan) {
    // If previous plan was Premium and selected plan is not premium, it is a downgrade
    if (this.hasAppointmentsPremium && plan.token !== APPOINTMENTS_PREMIUM_TOKEN) {
      return true;
    } else if (
    // If previous plan was Plus and selected plan is free, it is a downgrade
    this.planToken === APPOINTMENTS_PLUS_TOKEN && plan.token === APPOINTMENTS_FREE_TOKEN) {
      return true;
    }
    // Otherwise, it is not a downgrade
    return false;
  }
  isPlanUpgrade(plan) {
    // If previous plan was free and selected plan is not free, it is an upgrade
    if (this.planToken === APPOINTMENTS_FREE_TOKEN && plan.token !== APPOINTMENTS_FREE_TOKEN) {
      return true;
    }
    // If previous plan was Plus and selected plan is Premium, it is an upgrade
    if (this.planToken === APPOINTMENTS_PLUS_TOKEN && plan.token === APPOINTMENTS_PREMIUM_TOKEN) {
      return true;
    }
    // Otherwise, it is not an upgrade
    return false;
  }

  // Get the list of all active subunits for the merchant (these are not necessarily subscribed to appointments)
  getActiveSubunits() {
    if (!this.activeSubunitsFetched) {
      return this.fetchActiveSubunits();
    }
    return Promise.resolve(this.activeSubunits);
  }
  getPlanInfo(planToken) {
    if (planToken === APPOINTMENTS_LEGACY_TOKEN) {
      return undefined;
    }
    return this.planDetails[planToken];
  }
  getPlanDetailsOfFeature(featureId) {
    const planTokenOfFeature = this.appointmentsFeatureInfo.getPlanTokenOfFeature(featureId);
    if (!planTokenOfFeature) {
      return undefined;
    }
    return this.planDetails[planTokenOfFeature];
  }
  invalidateData() {
    set(this, 'dataLoaded', false);
  }
  async fetchActiveSubunits() {
    const subunits = await this.store.findAll('merchant-subunit-ed');
    const activeSubunits = subunits.filterBy('unitActive');
    set(this, 'activeSubunits', activeSubunits);
    this.activeSubunitsFetched = true;
    return activeSubunits;
  }

  // This is needed during the onboarding. GetSubscription throws an error
  async fetchAppointmentsPlanGroup(merchantToken, merchantCountryCode) {
    set(this, 'countryCode', merchantCountryCode);
    const response = await this.fetchAppointmentsPlanGroupPromise(merchantToken);
    this.parsePlanGroupResponse(response, merchantCountryCode);
  }
  fetchAppointmentsPlanGroupPromise(merchantToken) {
    const planGroupParams = {
      token: APPOINTMENTS_PLAN_GROUP_TOKEN,
      subscriber: {
        token_type: 'MERCHANT',
        token: merchantToken
      }
    };
    return jsonPost(GET_PLAN_GROUP_URL, planGroupParams);
  }
  acknowledgeMigrationPromise() {
    return jsonPost(ACKNOWLEDGE_SUBSCRIPTION_URL, {});
  }

  /**
   * @deprecated Use userSubscriptions.fetchAppointmentsFeatures instead
   *
   * We need to call GetPlanGroup even if the merchant is not part of appointments-group.
   // This only applies to the existing merchants within appointments who view the migration option.
   // The migration page needs the plan group information.
   * @param merchantToken
   * @param merchantCountryCode
   * @param hasAppointmentsAccount
   * @param forceRefresh
   */
  async fetch({
    merchantToken,
    merchantCountryCode,
    hasAppointmentsAccount,
    forceRefresh = false
  }) {
    this.merchantToken = merchantToken;
    if (this.subscriptionIsFetched && !forceRefresh) {
      return [];
    }
    if (!hasAppointmentsAccount) {
      return [];
    }
    set(this, 'countryCode', merchantCountryCode);
    set(this, 'dataLoaded', false);
    try {
      const subscriptionResponse = await this.getLegacySubscription();
      this.parseSubscriptionResponse(subscriptionResponse);
      const planGroupResponse = await this.getPlanGroup({
        merchantToken
      });
      if (planGroupResponse) {
        this.parsePlanGroupResponse(planGroupResponse, merchantCountryCode);
      }
      set(this, 'dataLoaded', true);
      return subscriptionResponse.active_features || [];
    } catch (error) {
      set(this, 'dataLoaded', false);
      throw error;
    }
  }
  getLegacySubscription() {
    return jsonPost(GET_SUBSCRIPTION_URL, {});
  }

  // Plan groups are only used for legacy subscriptions, not SQ1 subscriptions.
  getPlanGroup({
    merchantToken
  }) {
    return this.getSubscriptionPlans()?.length === 0 ?
    // If the planGroup already fetched, don't fetch it again.
    this.fetchAppointmentsPlanGroupPromise(merchantToken) :
    // If we should not fetch GetPlanGroup, we just resolve with nothing.
    null;
  }
  getMerchantCategories() {
    try {
      return jsonPost('/services/squareup.onboarding.business.external.BusinessExternalService/GetMerchantCategories', {});
    } catch (error) {
      if (error.status === 404) {
        return GetMerchantCategoriesResponse.create({
          category: BusinessCategory.BUSINESS_CATEGORY_UNKNOWN,
          subcategory: BusinessSubcategory.BUSINESS_SUBCATEGORY_UNKNOWN
        });
      }
      throw error;
    }
  }
  parseSubscriptionResponse(response) {
    set(this, 'activeFeatures', response.active_features);
    set(this, 'subscription', response.subscription);
    set(this, 'paywall', response.paywall);
    set(this, 'subscribedLocations', response.subscribed_locations ?? []);
    set(this, 'migrationState', response.migration_state);
  }
  parsePlanGroupResponse(response, merchantCountryCode) {
    const planDetails = {};
    set(this, 'planGroup', response.plan_group);
    const plans = response.plan_group.plans;
    plans.forEach(plan => {
      let pricingCost = plan.pricing.bucket_pricing?.cost;
      if (!pricingCost) {
        pricingCost = plan.pricing.fixed_pricing?.cost;
      }
      if (!pricingCost) {
        pricingCost = {
          amount: 0,
          currency_code: 'USD'
        };
      }
      const numFreeTrialDays = this.freeTrialHasEndedForLegacySubscription ? 0 : plan.num_free_trial_days;
      const featureList = this.appointmentsFeatureInfo.getFeatureListOfPlan(plan.token, merchantCountryCode);
      const featureTooltips = this.appointmentsFeatureInfo.getTooltipsOfPlan(plan.token, merchantCountryCode);
      planDetails[plan.token] = new PlanDetails(plan.token, this.appointmentsFeatureInfo.getPlanName(plan.token), this.appointmentsFeatureInfo.getPreviousPlanName(plan.token) ?? '', pricingCost.amount, pricingCost.currency_code, featureList, featureTooltips, numFreeTrialDays, plan.renewal_cycle);
    });
    set(this, 'planDetails', planDetails);
  }
  redirectToSubscriptionPage({
    unitToken,
    source,
    selectedPlanToken,
    planGroupToken
  }) {
    const encodedUnitToken = window.encodeURIComponent(unitToken);
    const encodedSource = window.encodeURIComponent(source);
    let url = `/dashboard/account/pricing?unitToken=${encodedUnitToken}`;
    // Only add the `source` query parameter if the merchant is not pending cancellation or downgrade, as adding
    // the `source` opens the Manage Subscriptions modal and can lead to an error when downgrading a second time
    if (this.isNotPendingCancellationOrDowngrade) {
      url += `&source=${encodedSource}`;
    }
    if (selectedPlanToken) {
      const encodedSelectedPlan = window.encodeURIComponent(selectedPlanToken);
      url += `&planToken=${encodedSelectedPlan}`;
    }
    if (planGroupToken) {
      const encodePlanGroupToken = window.encodeURIComponent(planGroupToken);
      url += `&planGroup=${encodePlanGroupToken}`;
    }
    redirect(url);
  }
  async updateAppointmentsSubscription({
    selectedPlan,
    subscribedLocations,
    reason,
    selectedPlanComponents,
    previousRetryCount,
    Sentry
  }) {
    const retryCount = previousRetryCount || 1;
    let newSubscriptionPlanTokens = [];
    if (selectedPlanComponents) {
      newSubscriptionPlanTokens = selectedPlanComponents.map(planComponent => planComponent.plan?.token ?? '');
    }
    const planToken = selectedPlan.token;
    const newSubscribedLocations = subscribedLocations ? [...subscribedLocations] : [];
    let idempotenceToken;
    if (this.lastParams && this.lastParams.plan_token === planToken && this._arrayEqual(this.lastParams.subscribed_locations, newSubscribedLocations) && this._arrayEqual(this.lastParams.new_subscription_plan_tokens, newSubscriptionPlanTokens)) {
      idempotenceToken = this.lastParams.idempotence_token;
    } else {
      idempotenceToken = uuid();
    }
    const params = {
      idempotence_token: idempotenceToken,
      plan_token: planToken,
      subscribed_locations: newSubscribedLocations,
      reason,
      new_subscription_plan_tokens: newSubscriptionPlanTokens
    };

    // We need to keep the last params in case the merchant tries to hit the confirm button again
    // after an error message shows up. This is to make sure that the idempotence_token is reused,
    // in case the backend was half successful.
    this.lastParams = params;
    try {
      // Send the request
      await jsonPost(APPT_UPDATE_SUBSCRIPTION_URL, params);

      // If the request is successful, delete the cached params.
      this.lastParams = null;

      // Then mark the data as invalid
      this.invalidateData();

      // Then close the modal
      return {
        closeAll: true,
        didSubscribe: true
      };
    } catch (err) {
      if (Sentry) {
        Sentry.captureException(err);
      }
      // If the request fails, try again for 2 more times.
      if (retryCount < 3) {
        return this.updateAppointmentsSubscription({
          selectedPlan,
          subscribedLocations,
          reason,
          selectedPlanComponents,
          previousRetryCount: retryCount + 1,
          Sentry
        });
      } else {
        return err;
      }
    }
  }
  _arrayEqual(arr1, arr2) {
    if (isEmpty(arr1) && isEmpty(arr2)) {
      return true;
    }
    if (isEmpty(arr1) || isEmpty(arr2)) {
      return false;
    }
    return arrayEqual(arr1, arr2);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "appointmentsFeatureInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "status", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "planToken", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "planName", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "token", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "freeTrialEndDate", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "freeTrialEndDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "freeTrialEndDateMonthDay", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "freeTrialEndDateMonthDay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "subscriptionEndDate", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "subscriptionEndDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pauseDate", [_dec8], Object.getOwnPropertyDescriptor(_class.prototype, "pauseDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "renewalAtDate", [_dec9], Object.getOwnPropertyDescriptor(_class.prototype, "renewalAtDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "startDate", [_dec10], Object.getOwnPropertyDescriptor(_class.prototype, "startDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isOldPlan", [_dec11], Object.getOwnPropertyDescriptor(_class.prototype, "isOldPlan"), _class.prototype), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "isNewPlan", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "canMigrateToNewSaaSTiers", [_dec13], Object.getOwnPropertyDescriptor(_class.prototype, "canMigrateToNewSaaSTiers"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isPlusFreeTrial", [_dec14], Object.getOwnPropertyDescriptor(_class.prototype, "isPlusFreeTrial"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isOnFreeSubscription", [_dec15], Object.getOwnPropertyDescriptor(_class.prototype, "isOnFreeSubscription"), _class.prototype), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "isPendingDowngrade", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "isPendingCancellationOrDowngrade", [_dec17], Object.getOwnPropertyDescriptor(_class.prototype, "isPendingCancellationOrDowngrade"), _class.prototype), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "isNotPendingCancellationOrDowngrade", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "freeTrialHasEndedForLegacySubscription", [_dec19], Object.getOwnPropertyDescriptor(_class.prototype, "freeTrialHasEndedForLegacySubscription"), _class.prototype), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "subscriptionIsFetched", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "hasNoSubscribedLocations", [_dec21], Object.getOwnPropertyDescriptor(_class.prototype, "hasNoSubscribedLocations"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "needsMigrationAcknowledgement", [_dec22], Object.getOwnPropertyDescriptor(_class.prototype, "needsMigrationAcknowledgement"), _class.prototype), _class);
export { AppointmentsSubscriptionService as default };